import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import ZofinoCalendar from "../../../system/components/zofino-calendar";
import TaskSidebar from "../../projects/components/task-sidebar";
import TaskDialog from "../task-dialog";
import TaskListFilter from "../components/task-list-filter";
import {calendarEventFromTask, CalendarEventContent, useRecurrenceCalendar} from "../components/recurrence-calendar";

function Calendar({tasks,createTask, updateTask}) {
    const calendarPrimaryToolbarId = "tasks-calendar-primary-toolbar";
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const [events, setEvents] = useState([]);
    const [selectedTask, setSelectedTask] = useState();
    const [taskDialogVisible, setTaskDialogVisible] = useState();
    const [selectedDate, setSelectedDate] = useState();
    const [filteredTasks, setFilteredTasks] = useState(tasks ?? []);
    const recurrence = useRecurrenceCalendar({
        tasks,
        updateTask,
        setSelectedTask,
        assigneeDocumentId: workspaceMembershipData?.documentId,
    });

    useEffect(() => {
        setFilteredTasks(tasks ?? []);
    }, [tasks]);

    useEffect(() => {
        setEvents(filteredTasks.filter(t=>t.startAt!==null||t.dueDate!==null).map(calendarEventFromTask))
    }, [filteredTasks]);

    return(
        <div className="h-full min-h-0 flex flex-column">
            <TaskListFilter calendarMode calendarPrimaryToolbarId={calendarPrimaryToolbarId} showDateFilter tasks={tasks} onChange={setFilteredTasks}/>
            <div className="flex-1 min-h-0">
                <ZofinoCalendar taskToolbar primaryToolbarTargetId={calendarPrimaryToolbarId} onAddEventClick={(e)=>{setSelectedDate(e);setTaskDialogVisible(true)}} eventTemplate={CalendarEventContent} events={[...events, ...recurrence.projectedEvents]} setEvents={setEvents} onRangeChange={recurrence.onRangeChange} onEventClick={recurrence.onEventClick} onEventResize={recurrence.onEventResize} onEventDropped={recurrence.onEventDropped}/>
            </div>
            {tasks&&<TaskSidebar selectedTask={tasks.find(task=>task.id===selectedTask?.id) ?? selectedTask} setSelectedTask={setSelectedTask} updateTask={updateTask} />}
            {recurrence.scopeDialog}
            <TaskDialog setVisible={setTaskDialogVisible} visible={taskDialogVisible} payload={{taskData:{startAt:new Date(selectedDate).getTime()/1000, dueDate: new Date(selectedDate).getTime()/1000}}} onSubmit={(e)=>{createTask(e); setTaskDialogVisible(false)}}/>
        </div>
    )
}

export default Calendar;
